module.exports = __webpack_public_path__ + "img/banner.72513767.jpg";